import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableRow } from '@mui/material';
import { CustomTableHead, CustomTableHeadText, CustomTableHeadCell } from './OptimizerTable.styles';
const OptimizerTableHead = () => {
  const { t } = useTranslation('optimizer');
  return (
    <CustomTableHead>
      <TableRow>
        <CustomTableHeadCell>
          <CustomTableHeadText>
            {t('table.title')}
          </CustomTableHeadText>
        </CustomTableHeadCell>
        <CustomTableHeadCell align="right">
          <CustomTableHeadText>
            {t('table.averagePrice')}
          </CustomTableHeadText>
        </CustomTableHeadCell>
      </TableRow>
    </CustomTableHead>
  );
};
export default OptimizerTableHead;
